export default __webpack_public_path__ + "static/media/part-two-bell-img.5620a4f3.svg";